/* eslint-disable @typescript-eslint/ban-types */
import type { FC } from 'react';
import React, { useContext } from 'react';
import { ModalContext, UploadContext } from 'ricos-context';
import { Uploader } from 'wix-rich-content-plugin-commons';

import { imageModals } from '../consts';
import { setupImageEditor } from '../imageStudio/image-editor-logic';
import type { ImagePluginService } from '../toolbar/imagePluginService';
import type { ImageEditorWixSettings } from '../types';
import { IMAGE_TYPE } from '../types';

interface Props {
  nodeId: string;
  src: string;
  imagePluginService: ImagePluginService;
  handleFileUpload;
  imageEditorWixSettings: ImageEditorWixSettings;
  onImageEditorOpen?: () => void;
}

const ImageEditorModal: FC<Props> = ({
  nodeId,
  imagePluginService,
  handleFileUpload,
  imageEditorWixSettings,
  onImageEditorOpen,
  src,
}) => {
  const uploader = new Uploader(handleFileUpload);
  const modalService = useContext(ModalContext) || {};
  const uploadContext = useContext(UploadContext) || {};

  const id = 'imageEditor';

  React.useEffect(() => {
    const onClose = () => {
      modalService.closeModal(imageModals.imageEditor);
    };

    const onSave = (file: File) => {
      uploadContext.uploadService?.uploadFile(
        file,
        nodeId,
        uploader,
        IMAGE_TYPE,
        imagePluginService
      );
      onClose();
    };

    onImageEditorOpen && onImageEditorOpen();

    setupImageEditor(imageEditorWixSettings, id, src, onSave, onClose);
  }, []);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line react/no-unknown-property
  return <div id={id} nofocus="true" />;
};

export default ImageEditorModal;
